import ResultsConRenderer from "./ResultsConRenderer";
import { EnumEventBus, eventBus } from "../../managers/EventBus";


export default class ResultsCon {
  private ResultsConRenderer = new ResultsConRenderer();

  constructor() {
    this.setVisible(false);
    eventBus.on(EnumEventBus.checkedAnswers, (arr: (boolean | null)[]) => this.showResults(arr));
    eventBus.on(EnumEventBus.setQuestMode, () => this.setVisible(false));
  }
  setVisible = (v: boolean) => this.ResultsConRenderer.visible = v;
  showResults(arr: (boolean | null)[]) {
    const totQuest = arr.length;
    const trueCount = arr.filter(a => a).length;
    this.ResultsConRenderer.setResult(totQuest, trueCount, trueCount * 5);
    this.setVisible(true);
  }
}